export default __webpack_public_path__ + "static/media/next@2x.e0e24bea.png";